import { useEffect, useMemo, useRef, useState } from 'react';
import { getDaysDiff } from '../../../../utils';
import { formatDateBr, parseSearchFromPath } from '../utils/searchParsing';

export const useSearchBarCommon = (destinations) => {
    const containerRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [containerHeight, setContainerHeight] = useState(0);

    const getDestinationName = (slug) => {
        if (!slug) return '';
        const list = destinations || [];
        const found = list.find((d) => d.slug === slug);
        return found ? found.name : '';
    };

    const { computedDestinationName, beginBr, endBr, permanence } = useMemo(() => {
        const { destinationSlug, beginDate, endDate } = parseSearchFromPath();
        const destinationName = getDestinationName(destinationSlug);
        const begin = formatDateBr(beginDate);
        const end = formatDateBr(endDate);

        let perm = '';
        if (beginDate && endDate) {
            const diff = getDaysDiff(new Date(beginDate), new Date(endDate));
            perm = !Number.isNaN(diff) ? `${diff} dias` : '';
        }

        return { computedDestinationName: destinationName, beginBr: begin, endBr: end, permanence: perm };
    }, [destinations]);

    useEffect(() => {
        const el = containerRef.current;
        setIsScrolled((window.scrollY || window.pageYOffset || 0) > 8);
        if (el) setContainerHeight(el.offsetHeight || 0);

        let ro;
        let onResizeFallback = null;
        if (typeof ResizeObserver !== 'undefined' && el) {
            ro = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const h = (entry.contentRect && entry.contentRect.height) || el.offsetHeight || 0;
                    setContainerHeight(h);
                }
            });
            ro.observe(el);
        } else {
            onResizeFallback = () => {
                if (el) setContainerHeight(el.offsetHeight || 0);
            };
            window.addEventListener('resize', onResizeFallback);
        }

        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(() => {
                    const y = window.scrollY || window.pageYOffset || 0;
                    setIsScrolled(y > 8);
                    ticking = false;
                });
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
            if (ro) ro.disconnect();
            if (onResizeFallback) window.removeEventListener('resize', onResizeFallback);
        };
    }, []);

    return { containerRef, isScrolled, containerHeight, computedDestinationName, beginBr, endBr, permanence };
};



// WEBPACK FOOTER //
// ./src/views/v2/search/hooks/useSearchBarCommon.js